import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  style: {"width":"28px","height":"28px"},
  viewBox: "0 0 24 24"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M5 16L3 5L8.5 10L12 4L15.5 10L21 5L19 16H5M19 19C19 19.6 18.6 20 18 20H6C5.4 20 5 19.6 5 19V18H19V19Z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "text-sm flex-1 truncate" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "material-icons text-primary text-sm mr-0.5" }, "auto_awesome", -1)
const _hoisted_8 = { class: "font-semibold text-sm tabular-nums" }
const _hoisted_9 = {
  key: 0,
  class: "flex items-center gap-1 mt-3 flex-wrap"
}
const _hoisted_10 = {
  key: 1,
  class: "opacity-60 text-primary-light font-medium px-1"
}
const _hoisted_11 = {
  key: 1,
  class: "flex flex-col items-center py-6 opacity-40"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "material-icons-outlined text-5xl" }, "leaderboard", -1)
const _hoisted_13 = { class: "text-sm mt-1" }
const _hoisted_14 = {
  key: 1,
  class: "space-y-2 py-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_Btn = _resolveComponent("Btn")!

  return (!_ctx.firstLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        ((_ctx.paginatedUsers?.count ?? 0) > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedUsers?.data, (user, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: 'leaderboard-user-' + index,
                  class: _normalizeClass(["py-2 px-1 flex items-center", { 'bg-gray-50 rounded': index % 2 }])
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["mr-2 shrink-0", {
						'text-yellow-400': _ctx.pageNumber === 1 && index === 0,
						'text-gray-400': _ctx.pageNumber === 1 && index === 1,
						'text-bronze': _ctx.pageNumber === 1 && index === 2,
					}]),
                    style: {"width":"28px","height":"28px","position":"relative"}
                  }, [
                    (_ctx.pageNumber === 1 && index < 3)
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_3, _hoisted_5))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", {
                      class: _normalizeClass([{
							'font-medium text-xs drop-shadow filter': _ctx.pageNumber === 1 && index < 3,
							'text-yellow-800': _ctx.pageNumber === 1 && index === 0,
							'text-gray-900': _ctx.pageNumber === 1 && index === 1,
							'text-yellow-900': _ctx.pageNumber === 1 && index === 2,
							'text-muted text-sm': !(_ctx.pageNumber === 1 && index < 3),
						}, "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform"])
                    }, _toDisplayString(_ctx.getUserPosition(user.id)), 3)
                  ], 2),
                  _createVNode(_component_Avatar, {
                    size: 'xs',
                    class: "mr-2 ml-1 shrink-0",
                    user: user
                  }, null, 8, ["user"]),
                  _createElementVNode("p", _hoisted_6, _toDisplayString(user.full_name), 1),
                  _hoisted_7,
                  _createElementVNode("p", _hoisted_8, _toDisplayString(user.reputation), 1)
                ], 2))
              }), 128)),
              (_ctx.lastPageNumber > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageNumbers, (page) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: 'page-btn-' + page
                      }, [
                        (page !== _ctx.pageNumber)
                          ? (_openBlock(), _createBlock(_component_Btn, {
                              key: 0,
                              size: "xs",
                              onClick: ($event: any) => (_ctx.changePage(page)),
                              variant: "primary-borderless"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(page), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(page), 1))
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("gamification.no_leaderboard")), 1)
            ]))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_14, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
          return _createElementVNode("div", {
            key: i,
            class: "h-8 bg-gray-100 rounded animate-pulse"
          })
        }), 64))
      ]))
}